import { createAction } from '@reduxjs/toolkit';
import { scenarioPlayerSlice } from './scenarioPlayerSlice.ts';

export const ScenarioPlayerActions = {
  ...scenarioPlayerSlice.actions,
};
